<template>
  <div>
    <div
      :class="{ 'studio-page-header-long' : !is_sidebar_minimized }"
      class="studio-page-header"
      style="padding-bottom: 0 !important; padding-top: 15px !important; height: 110px">
      <div class="title-tab-experience-manager">ADMINISTRATOR</div>
      <div class="d-flex m__t--45">
        <template v-for="(tab, index) in tabMenu">
          <div
            v-if="tab.show"
            :key="tab.label"
            :class="[
              { 'm__r--35': index < tabMenu.length - 1 },
              tab.active ? 'tab-experience-manager-active' : 'tab-experience-manager'
            ]"
            @click="$router.replace(tab.url)"
          >
            {{ tab.label }}
          </div>
        </template>
      </div>
    </div>

    <div class="studio-page-administrator-content">
      <div class="custom-table-search">
        <v-server-table
          v-show="load_first"
          ref="divisionServer"
          :columns="columns"
          :options="options"
          class="jTable"
          @loading="loading"
          @loaded="loaded"
          @row-click="onClickDetail"
        >
          <div
            slot="beforeFilter"
            class="custom-search">
            <b-form
              inline
              @keypress.13.prevent="filter(filter_data)">
              <b-button
                class="btn grey btn-import-form m__r--5"
                @click="showModal">
                <i class="fa fa-plus fa-lg"/> Add
              </b-button>
              <!-- <b-button
                class="btn grey btn-import-form m__r--5"
                @click="exportDivisionToEmail">
                <i class="fa fa-download fa-lg"/> Export
              </b-button> -->
              <span/>
              <j-select
                v-model="select_type"
                :disabled="false"
                :options="options_search"
                placeholder="Filter By"
                class="m__r--5"/>
              <b-form-group>
                <b-form-input
                  ref="filterInput"
                  v-model="filter_data"
                  placeholder="Search"
                  class="m__r--5"/>
              </b-form-group>
            </b-form>
          </div>

          <div
            slot="checkbox"
            slot-scope="props"
            class="jTableReport">
            <b-form-group>
              <b-form-checkbox-group v-model="selected_rows">
                <b-form-checkbox :value="props.row"/>
              </b-form-checkbox-group>
            </b-form-group>
          </div>

          <div
            slot="created_date"
            slot-scope="props"
          >
            {{ props.row.created_date | moment("MMM DD, YYYY") }}
          </div>

          <div
            slot="updated_date"
            slot-scope="props"
          >
            {{ props.row.updated_date | moment("MMM DD, YYYY") }}
          </div>
        </v-server-table>

        <div>
          <jLoadingTable v-if="!load_first"/>
        </div>
      </div>
    </div>
    <j-division-create
      v-if="isModalOpen"
      @closemodal="showModal"/>
  </div>
</template>

<script>
/* eslint-disable vue/name-property-casing */
/* eslint-disable import/no-duplicates,import/prefer-default-export,object-shorthand */
/* eslint-disable no-unused-expressions,no-unused-vars,key-spacing */

import { mapActions, mapState } from 'vuex';
import jApiDivisionFlow from '@/services/jApiDivisionFlow';
import jLoadingTable from '@/components/skeleton-loading/jLoadingTable';
import jDivisionCreate from '@/views/division/jDivisionCreate';

export default {
  name: 'jDivisionList',
  components: {
    jLoadingTable,
    jDivisionCreate,
  },
  data() {
    return {
      isModalOpen: false,
      filter_data: '',
      select_type: 'name',
      options_search: [
        {
          text: 'ID',
          value: 'id',
        },
        {
          text: 'Name',
          value: 'name',
        },
        {
          text: 'Code',
          value: 'code',
        },
        {
          text: 'Created Date',
          value: 'created_date',
        },
      ],
      data_table: [],
      selected_rows: [],
      load_first: false,
      columns: ['id', 'name', 'code', 'total_position', 'created_date', 'updated_date'],
      options: {
        headings: {
          id: 'ID',
          name: 'NAME',
          code: 'CODE',
          total_position: 'TOTAL POSITION',
          created_date: 'CREATED DATE',
          updated_date: 'UPDATED DATE',
        },
        texts: {
          filterPlaceholder: 'Search',
          limit: 'Rows per page',
        },
        sortIcon: {
          base: 'fa',
          up: 'fa-chevron-up',
          down: 'fa-chevron-down',
          is: 'fa-sort',
        },
        debounce: 1000,
        filterable: true,
        sortable: ['id', 'name', 'code', 'created_date', 'updated_date'],
        perPage: 10,
        perPageValues: [10, 20, 50, 100],
        requestAdapter(data) {
          return {
            pagination: {
              limit: data.limit,
              page: data.page,
              column: data.orderBy ? data.orderBy : 'id',
              ascending: !data.ascending,
              query: data.query ? data.query : '',
              query_type: data.query_type ? data.query_type : '',
            },
          };
        },
        requestFunction(data) {
          const getListDivision = jApiDivisionFlow.getDivisionList(data);
          return getListDivision.catch((e) => {
            this.$store.dispatch('jStoreNotificationScreen/toggleProblem', e.response.data.errors[0].message).bind(this);
          });
        },
        responseAdapter({ data }) {
          return {
            data: data.data ? data.data : [],
            count: data.length !== undefined ? data.length : 0,
          };
        },
        templates: {
          total_position(h, row) {
            const total = row.organigram_ids.length;
            return <div>{total}</div>;
          },
        },
      },
    };
  },
  computed: {
    ...mapState('jStoreDivisionFlow', ['division_created']),
    ...mapState('jStoreSetting', ['is_sidebar_minimized']),
    ...mapState('jStoreLogin', ['profile_data']),

    role() {
      return Number(localStorage.getItem('userRole') || this.profile_data.userRole);
    },

    tabMenu() {
      return [
        { url: '/administrator', label: 'USER', show: true, active: false },
        { url: '/administrator/position', label: 'POSITION', show: true, active: false },
        { url: '/administrator/unit', label: 'UNIT', show: true, active: true },
        { url: '/administrator/location', label: 'LOCATION', show: true, active: false },
        { url: '/administrator/layer', label: 'LAYER', show: true, active: false },
        { url: '/administrator/company/profile', label: 'COMPANY', show: true, active: false },
        { url: '/administrator/company/settings', label: 'SETTINGS', show: this.role === 1, active: false },
      ];
    },
  },
  watch: {
    division_created() {
      this.$refs.divisionServer.getData();
    },

    filter_data(val) {
      if (val === '') {
        this.$refs.divisionServer.setFilter('');
      }
    },

    selected_rows() {
      if (this.selected_rows.length === 0) {
        this.$refs.floating.hide();
      } else {
        this.$refs.floating.show();
      }
    },

    load_first(val) {
      if (val) {
        setTimeout(() => {
          this.$refs.filterInput.focus();
        }, 200);
      }
    },
  },
  methods: {
    ...mapActions('jStoreNotificationScreen', ['toggleProblem', 'showLoading', 'hideLoading']),

    loading(val) {
      const a = val;
      a.pagination.query_type = this.select_type;
      if (this.load_first) {
        this.showLoading();
      }
    },

    loaded(data) {
      this.data_table = data.data.data;
      if (this.load_first) {
        this.hideLoading();
      } else {
        this.load_first = !this.load_first;
      }
    },

    refreshTable() {
      this.$refs.divisionServer.getData();
    },

    filter(val) {
      this.$refs.divisionServer.setFilter(val);
    },

    onClickDetail(data) {
      this.$router.push(`/administrator/unit/update/${data.row.id}`);
    },
    exportDivisionToEmail() {
      const req = {
        type: 'xls',
        send_mail_type: 1,
      };
      this.$store.dispatch('jStoreOrganigram/exportDivisionToEmail', req);
    },
    showModal() {
      this.isModalOpen = !this.isModalOpen;
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/division/jDivisionList.vue